import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./LessThanMarket.module.css";
var LessThanMarket = function LessThanMarket(_ref) {
  var lowMileage = _ref.lowMileage;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ContlesThan,
    id: "low-mileage-badge"
  }, /*#__PURE__*/React.createElement("span", {
    id: "low-mileage-prefix"
  }, lowMileage === null || lowMileage === void 0 ? void 0 : lowMileage.pre_text), /*#__PURE__*/React.createElement("strong", {
    id: "low-mileage-value"
  }, " ", lowMileage === null || lowMileage === void 0 ? void 0 : lowMileage.value_text), /*#__PURE__*/React.createElement("span", {
    id: "low-mileage-suffix"
  }, t("كم في السنة", {
    ns: "web_post_view"
  })));
};
export default LessThanMarket;